import {
  WalletOption,
  WalletOptionIcon,
  WalletOptionImg,
  WalletOptionName,
} from './styles'
import { Connector, useConnect } from '@starknet-react/core'
import { startCase } from 'lodash'
import Loading from '../Loading'
import { updateChainType } from '../../store/connect/reducer'
import { useAppDispatch } from '../../store'
import { ChainType } from '../../constants/chains'
import { useIsDepositPage } from '../../store/deposit/hook'
import { updateModal } from '../../store/app/actions/modalActions'

export default function StarknetWalletOption({
  connector,
}: {
  connector: Connector
}) {
  const dispatch = useAppDispatch()
  const { connectAsync, isPending } = useConnect()
  const isDepositPage = useIsDepositPage()
  return (
    <WalletOption
      onClick={() => {
        connectAsync({ connector }).then((r) => {
          dispatch(updateChainType({ chainType: ChainType.Starknet }))
          dispatch(updateModal({ modal: 'wallets', open: false }))

          if (!isDepositPage) {
            dispatch(updateModal({ modal: 'verify', open: true }))
          }
        })
      }}
    >
      <WalletOptionIcon>
        <WalletOptionImg src={connector.icon.dark} alt={connector.name} />
      </WalletOptionIcon>
      <WalletOptionName>{startCase(connector.name)}</WalletOptionName>
      {isPending && <Loading />}
    </WalletOption>
  )
}
